import { logger } from '@lessonup/logging-classic';
import { ActionButton, DefaultForm, Modal, ModalButtonBar, Text, ModalProps } from '@lessonup/typescript-core/ui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import { useAppServices } from '../../appServices/AppServicesContext';
import './FlagLessonModal.less';

export interface FlagLessonModalConfig {
  lessonId: string;
}

const TRANSLATION_NAMESPACE = 'flagModal';

function FlagLessonModal(props: ModalProps<undefined> & FlagLessonModalConfig) {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  const { lesson } = useAppServices();
  const [comment, setComment] = useState<string | undefined>(undefined);
  const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

  function handleClose() {
    return props.closeModal(undefined);
  }

  async function onSubmit() {
    if (!comment) {
      return;
    }
    try {
      await lesson.flagLesson(props.lessonId, comment);
      setFormSubmitted(true);
    } catch (error) {
      logger.error(error);
    }
  }

  function modalContent() {
    return formSubmitted ? (
      <ConfirmMessage text={t('confirmation')} closeModal={handleClose} />
    ) : (
      <FlagLessonForm comment={comment} setComment={setComment} onSubmit={onSubmit} />
    );
  }

  return (
    <Modal title={t(formSubmitted ? 'confirmationTitle' : 'title')} isOpen onRequestClose={handleClose} width="medium">
      {modalContent()}
    </Modal>
  );
}

interface FlagLessonFormProps {
  comment: string | undefined;
  setComment: (c: string) => void;
  onSubmit: () => void;
}

const FlagLessonForm: React.FunctionComponent<FlagLessonFormProps> = ({ comment, setComment, onSubmit }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  return (
    <>
      <div className="flagmodal__header">
        <div className="flagmodal_headertext">
          <Text translateKey="description" options={{ ns: TRANSLATION_NAMESPACE }} />
        </div>
      </div>
      <br />
      <DefaultForm className="flagmodal-form" handleSubmit={onSubmit}>
        <textarea
          className="capsule-textarea-field capsule-sizing-default capsule-color-default"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder={t('your-comment')}
          required
        />
        <ModalButtonBar layout="center">
          {/* eslint-disable-next-line jsx-a11y/aria-role -- auto-generated TECH-258 */}
          <ActionButton theme="primary" type="submit" role="submit">
            <Text translateKey="send" options={{ ns: TRANSLATION_NAMESPACE }} />
          </ActionButton>
        </ModalButtonBar>
      </DefaultForm>
    </>
  );
};

const ConfirmMessage: React.FunctionComponent<{ text: string; closeModal: (res: undefined) => void }> = (props) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- auto-generated TECH-258
  function clickHandler(e: React.MouseEvent | React.TouchEvent) {
    props.closeModal(undefined);
  }

  return (
    <div>
      <div className="flagmodal__header">
        <div className="flagmodal_headertext">{props.text}</div>
      </div>
      <ModalButtonBar layout="center">
        <ActionButton theme="light" onClick={clickHandler}>
          {t('ok')}
        </ActionButton>
      </ModalButtonBar>
    </div>
  );
};

export default FlagLessonModal;
